import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";

export default function OneService({ image, title, description, navToLink = {} }) {

	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		setReady(true);
	}, []);

	return (
		<div 
			data-aos="fade-down"
			className="col-md-4 p-2"
			style={{ cursor: "pointer" }}
			onClick={() => appContext.navTo(navToLink)}
		>
			<div
				className="rounded"
				style={{
					backgroundImage: `url(${image})`, // <-- BACKGROUND CHANGES PER SERVICE
					backgroundAttachment: "fixed",
					backgroundSize: "cover",
					backgroundPosition: "center",
					height: "45vh",
					position: "relative",
					overflow: "hidden"
				}}
			>
				<div
					className="text-light"
					style={{
						position: "absolute",
						inset: 0,
						background: "rgba(17, 42, 111, 0.75)",
						padding: "20px"
					}}
				>
					<h5 className="mt-2 font-bold">{title}</h5>

					<h6 className="mt-2" style={{ fontWeight: 400 }}>
						{description}
					</h6>

					<button className="btn btn-outline-light rounded mt-3">
						Learn more
					</button>
				</div>
			</div>
		</div>
	);
}
